import * as React from 'react';
import { useState } from 'react';
import Button from '../../../../../common/form/Button';
import Row from 'reactstrap/lib/Row';
import { Col } from 'reactstrap';
import { ManualAccess, CodeStatus } from '../../../../../../api/PropertyIntegration';
import ManualAccessStatusDisplay from './ManualAccessStatusDisplay';

interface Props {
    initialBackupCode: ManualAccess | undefined;
    name: string | undefined;
    onBackupCodeSave: (newBackup: string, name: string) => void;
}

const ManualAccessBackupForm = (props: Props) => {
    const [backupCode, setBackupCode] = useState(
        (props.initialBackupCode && props.initialBackupCode.code) || ''
    );

    const [name, setName] = useState(
        (props.name) || ''
    );
    const [editing, setEditing] = useState(!props.initialBackupCode);

    const confirmDelete = () => {
        setEditing(false);
        if (
            props.initialBackupCode &&
            props.initialBackupCode.codeStatus === CodeStatus.InUse &&
            !confirm(
                'The backup code is currently in use by one or more prospects. ' +
                'If you have removed the code, their tour may be affected.'
            )
        ) {
            setBackupCode((props.initialBackupCode && props.initialBackupCode.code) || backupCode);
            return;
        }

        props.onBackupCodeSave(backupCode, name);
    };

    return (
        <>
            {!props.initialBackupCode && (
                <Row>
                    <Col md={{ size: 10, offset: 1 }}>
                        <h6>
                            First, please set a fallback code for use if the code list runs out.
                        </h6>
                    </Col>
                </Row>
            )}

            <Row className="backup-entry">
                <Col md={{ size: 3 }}>
                    <span>Backup Code: </span>
                    {editing ? (
                        <input
                            type="input"
                            className="form-control"
                            value={backupCode}
                            onChange={e => setBackupCode(e.target.value)}
                        />
                    ) : (
                        <span className="code-display">{backupCode}</span>
                    )}
                </Col>
                <Col md={{ size: 3, offset: 1 }}>
                    <span>Name: </span>
                    {editing ? (
                        <input
                            type="input"
                            className="form-control"
                            value={name}
                            onChange={e => setName(e.target.value)}
                        />
                    ) : (
                        <span className="code-display">{name}</span>
                    )}
                </Col>
                <Col md={{ size: 1, offset: 1 }}>
                    <ManualAccessStatusDisplay
                        status={
                            (props.initialBackupCode && props.initialBackupCode.codeStatus) ||
                            CodeStatus.Active
                        }
                    />
                </Col>
                <Col md={3}>
                    {editing ? (
                        <div>
                            <Button
                                suppressBottomMargin={true}
                                text="Save"
                                onClick={confirmDelete}
                            />
                            {props.initialBackupCode && (
                                <Button
                                    suppressBottomMargin={true}
                                    addlClassName="secondary"
                                    text="Cancel"
                                    onClick={() => setEditing(false)}
                                />
                            )}
                        </div>
                    ) : (
                        <Button
                            text="Edit"
                            onClick={() => setEditing(true)}
                            suppressBottomMargin={true}
                        />
                    )}
                </Col>
            </Row>
        </>
    );
};

export default ManualAccessBackupForm;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/manualAccessControls/ManualAccessBackupForm.tsx